module.exports = __webpack_public_path__ + "static/media/logobi.63c39542.svg";